var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WithLoader',{attrs:{"isLoading":_vm.isLoading,"classType":"primary"}},[_c('div',{staticClass:"history-table__wrapper",class:( _obj = {}, _obj[_vm.extraClass] = !!_vm.extraClass, _obj )},[_c('VDataTable',{attrs:{"currentSort":_vm.sorting,"headers":_vm.tableFields.headers,"rows":_vm.tableFields.rows,"extraClass":"history-table","classType":"primary"},on:{"sort":_vm.onSort}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }